<template>
  <div
    class="home-container"
    ref="DOMl"
    :style="{ height: $store.state.isAndroid ? '100%' : 'auto' }"
  >
    <loading :show="loadingShow"></loading>
    <Header class="page-box" v-bind:isLogin="isLogin"></Header>
    <banner v-if="!isLiveTime"></banner>
    <div class="main-container">
      <live v-if="isLiveTime"></live>
      <introduce class="page-box"></introduce>
      <agenda class="page-box"></agenda>
      <Guest class="page-box"></Guest>
      <BigView class="page-box"></BigView>
      <ParaleelSessions class="page-box" v-if="false"></ParaleelSessions>
      <developer class="page-box"></developer>
      <sandbox class="page-box"></sandbox>
      <Partner class="page-box"></Partner>
      <Media class="page-box"></Media>
      <Advert></Advert>
      <news class="page-box"></news>
      <Videos v-if="!putType" class="page-box"></Videos>
    </div>
    <cook-tip></cook-tip>
    <foot></foot>
    <suspension></suspension>
    <position></position>
    <div
      v-if="!$store.state.isMobile"
      class="dem-home-page-bg"
      :class="isTop || isLiveTime ? 'is_top' : ''"
    >
      <div class="video-bg" :style="fixStyle"></div>
      <video
        :style="fixStyle"
        ref="videoBg"
        muted="muted"
        autoplay="autoplay"
        loop="loop"
        :src="videoUrl"
      ></video>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

let _ = require("lodash");

import Header from "../components/Header";
import Banner from "../components/Banner";
import Introduce from "../components/Introduce";
import Agenda from "../components/Agenda";
import Guest from "../components/Guest";
import Foot from "../components/Foot";
// import Exhibition from "../components/Exhibition";
import Developer from "../components/Developer";
import ParaleelSessions from "../components/ParallelSessions";
import News from "../components/News";
import CookTip from "../components/CookTip";
import BigView from "../components/BigView";
import Videos from "../components/Videos";
import Sandbox from "../components/Sandbox";
import Suspension from "../components/Suspension";
import Position from "../components/Position";
import Guide from "../components/Guide";
import Live from "../components/Live";
import Partner from "../components/Partner";
import Advert from "../components/Advert";
import Cookie from "js-cookie";

export default {
  name: "Home",
  data() {
    return {
      videoUrl: "",
      screenWidth: 0,
      screenHeight: 0,
      fixStyle: "",
      isLogin: true,
      isTop: false,
      loadingShow: true,
      isAndroid: false, //适配安卓 无法获取 scrolleTop  勿删
      putType: false,
      isLiveTime: false,
    };
  },
  components: {
    Header,
    Banner,
    Introduce,
    Agenda,
    Guest,
    Foot,
    // Exhibition,
    Developer,
    ParaleelSessions,
    News,
    CookTip,
    BigView,
    Videos,
    Sandbox,
    Suspension,
    Position,
    // Guide,
    Live,
    Partner,
    Advert,
    Media: () => import("../components/Media.vue"),
  },
  computed: mapState({
    nowTime: (state) => state.nowTime,
  }),
  created() {
    this.putType = !!(this.$route.query.putType || Cookie.get("putType"));
    if (!this.$store.state.isMobile) {
      this.videoUrl =
        "https://1500010779.vod2.myqcloud.com/6ca9a800vodcq1500010779/539617ba387702298424687152/p28l4pm3MZ0A.mp4";
    }
    // document.title = "因聚而生 为你所能|华为伙伴暨开发者大会2022";
  },
  mounted() {
    this.isLiveTime = this.nowTime > new Date("2022/06/14 22:00:00");
    // 监听滚动事件
    window.addEventListener(
      "scroll",
      () => {
        const scrollTop =
          document.documentElement.scrollTop || document.body.scrollTop;
        this.isTop =
          scrollTop > (500 * document.documentElement.clientWidth) / 1920;
      },
      true
    );
    // 注册事件 --onWindowResize中做防抖处理，同window.onresize
    window.addEventListener(
      "resize",
      _.debounce(
        () => {
          this.onWindowResize();
        },
        1000,
        false
      ),
      true
    );
    if (!this.isLiveTime) {
      this.$bus.$on("loadingShow", (res) => {
        if (res) {
          setTimeout(() => {
            this.loadingShow = false;
          }, 500);
        }
      });
    } else {
      setTimeout(() => {
        this.loadingShow = false;
      }, 500);
    }

    window.onresize = () => {
      const windowWidth = document.body.clientWidth;
      const windowHeight = document.body.clientHeight;
      const windowAspectRatio = windowHeight / windowWidth;
      let videoWidth;
      let videoHeight;
      if (windowAspectRatio < 0.5625) {
        videoWidth = windowWidth;
        videoHeight = videoWidth * 0.5625;
        this.fixStyle = {
          height: windowWidth * 0.5625 + "px",
          width: windowWidth + "px",
          "margin-bottom": (windowHeight - videoHeight) / 2 + "px",
          "margin-left": "initial",
        };
      } else {
        videoHeight = windowHeight;
        videoWidth = videoHeight / 0.5625;
        this.fixStyle = {
          height: windowHeight + "px",
          width: windowHeight / 0.5625 + "px",
          "margin-left": (windowWidth - videoWidth) / 2 + "px",
          "margin-bottom": "initial",
        };
      }
    };
    window.onresize();
    //伙伴百城行 跳转带参数
    if (this.$route.query && this.$route.query.utm_source) {
      Cookie.set("utm_source", this.$route.query.utm_source);
    }
  },
  methods: {
    link(url) {
      window.open(url); // 新窗口打开外链接
    },
    onWindowResize() {
      const h = document.documentElement.clientWidth; //获取页面可见高度
      if (h <= 992) {
        //总线进行发射数据  初始化 swiper
        this.$bus.$emit("reSwiper", true);
      }
    },
  },
  destroyed() {
    //销毁前 关闭时间总线
    this.$bus.$off("status");
    this.$bus.$off("reSwiper");
    this.$bus.$off("loadingShow");
    this.loadingShow = true;
  },
};
</script>
<style lang="scss" scoped>
@media screen and (min-width: 991px) {
  @import "./css/home/pc.scss";
}

@media screen and (max-width: 991px) {
  @import "./css/home/wap.scss";
}
</style>
